import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.fromList([
	'unknown',
	...constants.job.stage.ids,
	...constants.transaction.stage.ids,
]);

export const JobId = iotsUtils.fromList([...constants.job.stage.ids]);

export const TransactionId = iotsUtils.fromList([...constants.transaction.stage.ids]);
